(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["et-fan-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const trigger=event.target.closest('[data-fan-open]');if(trigger){const dialog=document.getElementById(trigger.dataset.fanOpen);if(!dialog)return;dialog.showModal();const video=dialog.querySelector('video');video.play().catch(()=>{});}const close=event.target.closest('.et-fans-close');if(close)close.closest('dialog').close();if(event.target.matches('.et-fans-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}});document.querySelectorAll('.et-fans-dialog').forEach(dialog=>dialog.addEventListener('close',()=>{dialog.querySelector('video').pause();}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["et-mystery-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const offer = 'mystery-tee-5-v1';
  class EverteeMysteryUpsell extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.owner = this.closest('evertee-owned-bundle');
      if (!this.owner) return;
      this.config = JSON.parse(this.querySelector('[data-mystery-config]').textContent);
      this.labels = this.config.labels;
      this.variants = this.config.variants;
      this.addButton = this.querySelector('[data-mystery-add]');
      this.removeButton = this.querySelector('[data-mystery-remove]');
      this.status = this.querySelector('[data-mystery-status]');
      this.review = this.querySelector('[data-mystery-review]');
      this.line = null;
      this.busy = false;
      this.ready = false;
      this.uncertain = false;
      this.nativeSignature = null;
      this.pendingKey = 'evertee-mystery-pending:' + this.dataset.sourceProduct;
      try { this.uncertain = !!sessionStorage.getItem(this.pendingKey); } catch (_) {}
      this.addButton.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.add(); });
      this.removeButton.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.remove(false); });
      this.sizeHandler = event => {
        if (event.target.closest('[data-owned-size]')) queueMicrotask(() => this.sizeChanged());
      };
      this.guardHandler = event => {
        if (!this.busy || !(event.type === 'submit' || event.target.closest('[data-owned-add],[data-owned-wallet]'))) return;
        event.preventDefault(); event.stopImmediatePropagation(); this.announce('wait');
      };
      this.owner.addEventListener('click', this.sizeHandler, true);
      this.owner.addEventListener('click', this.guardHandler, true);
      this.form = this.closest('form');
      this.form?.addEventListener('submit', this.guardHandler, true);
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.target.matches('[data-owned-size]'))) this.sizeChanged();
        else this.render();
      });
      this.observer.observe(this.owner, {attributes:true, subtree:true, attributeFilter:['aria-busy','aria-pressed']});
      this.focusHandler = () => { if (!document.hidden && !this.busy) this.sync().catch(() => {}); };
      document.addEventListener('visibilitychange', this.focusHandler);
      window.addEventListener('pageshow', this.focusHandler);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event.source !== 'evertee-mystery-upsell' && !this.busy) this.sync().catch(() => {});
        });
      }
      this.hidden = false;
      this.render();
      this.sync().catch(() => { this.announce('failed'); this.review.hidden = false; });
    }

    disconnectedCallback() {
      this.observer?.disconnect(); this.unsubscribe?.();
      this.owner?.removeEventListener('click', this.sizeHandler, true);
      this.owner?.removeEventListener('click', this.guardHandler, true);
      this.form?.removeEventListener('submit', this.guardHandler, true);
      document.removeEventListener('visibilitychange', this.focusHandler);
      window.removeEventListener('pageshow', this.focusHandler);
    }

    say(key, values = {}) {
      let value = this.labels[key] || '';
      for (const [name, replacement] of Object.entries(values)) value = value.replaceAll('__' + name.toUpperCase() + '__', replacement);
      return value;
    }

    announce(key, values) { this.status.textContent = this.say(key, values); }
    selected() { return this.variants.find(v => v.option1 === this.owner.size); }
    lineSize() { return this.variants.find(v => Number(v.id) === Number(this.line?.variant_id))?.option1; }
    matching(cart) { return cart.items.filter(item => String(item.product_id) === this.dataset.productId && item.properties?._et_upsell_offer === offer && item.properties?._et_source_product_id === this.dataset.sourceProduct); }
    endpoint(path) { return new URL(this.dataset.rootUrl.replace(/\/?$/, '/') + path, location.origin).href; }

    signature() { return this.line ? JSON.stringify([this.line.variant_id,this.line.quantity,this.line.properties]) : 'none'; }

    assertNativeReady() {
      if (!this.ready || this.busy || this.uncertain || this.nativeSignature !== this.signature() ||
          (this.line && this.lineSize() !== this.owner.size)) throw new Error('mystery-unconfirmed');
    }

    nativeBundle(bundle, cart) {
      this.applyCart(cart);
      if (this.busy || this.uncertain || this.matching(cart).length > 1) throw new Error('mystery-unconfirmed');
      const entries = bundle.toNativeFormEntries();
      if (this.line) {
        const variant = this.selected();
        if (!variant?.available || Number(variant.id) !== Number(this.line.variant_id) ||
            variant.price !== 500 || this.line.original_price !== 500 ||
            !Number.isSafeInteger(this.line.quantity) || this.line.quantity < 1) throw new Error('mystery-unconfirmed');
        const indices = entries.map(([name]) => Number(name.match(/^shopify-additional-items\[(\d+)\]/)?.[1] || 0));
        const prefix = 'shopify-additional-items[' + (Math.max(0,...indices) + 1) + ']';
        entries.push([prefix + '[id]',String(this.line.variant_id)], [prefix + '[quantity]',String(this.line.quantity)],
          [prefix + '[properties]',JSON.stringify(Object.entries(this.line.properties).map(([key,value]) => ({key,value:String(value)})))]);
      }
      this.nativeSignature = this.signature();
      return Object.freeze({
        ...bundle,
        toNativeFormEntries: () => entries.map(entry => entry.slice()),
        syncNativeForm: form => {
          window.EverteeBundleCore.clearNativeForm(form);
          const fragment = form.ownerDocument.createDocumentFragment();
          entries.forEach(([name,value]) => {
            const input = form.ownerDocument.createElement('input');
            input.type = 'hidden'; input.name = name; input.value = value;
            input.setAttribute('data-evertee-bundle-input','');
            fragment.appendChild(input);
          });
          form.appendChild(fragment);
          return entries;
        }
      });
    }

    async request(path, payload) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(this.endpoint(path), {
          method:payload ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', signal:controller.signal,
          headers:{Accept:'application/json', ...(payload ? {'Content-Type':'application/json'} : {})},
          ...(payload ? {body:JSON.stringify(payload)} : {})
        });
        if (!response.ok) { const error = new Error('request'); error.status = response.status; throw error; }
        return await response.json();
      } finally { clearTimeout(timeout); }
    }

    applyCart(cart) {
      if (cart.currency !== 'GBP') { this.ready = false; this.announce('currency_changed'); this.render(); throw new Error('currency'); }
      this.line = this.matching(cart)[0] || null;
      this.ready = true;
      if (this.line) this.clearPending();
      this.render();
      return cart;
    }

    async sync() {
      const previous = this.signature();
      const cart = this.applyCart(await this.request('cart.js'));
      if (!this.busy && !this.owner.busy && this.owner.catalog && this.owner.size &&
          (previous !== this.signature() || this.nativeSignature !== this.signature())) await this.owner.refresh();
      return cart;
    }
    markPending() { this.uncertain = true; try { sessionStorage.setItem(this.pendingKey, '1'); } catch (_) {} }
    clearPending() { this.uncertain = false; try { sessionStorage.removeItem(this.pendingKey); } catch (_) {} }

    render() {
      if (!this.addButton) return;
      const added = !!this.line;
      const ownerBusy = this.owner.busy || this.owner.getAttribute('aria-busy') === 'true';
      const unavailable = this.owner.size && !this.selected()?.available;
      this.addButton.disabled = this.busy || ownerBusy || added || unavailable || (this.uncertain && !added);
      this.addButton.dataset.added = String(added);
      this.querySelector('[data-mystery-icon]').textContent = added ? '✓' : '+';
      this.querySelector('[data-mystery-label]').textContent = this.busy ? this.say(this.operation === 'remove' ? 'removing' : 'adding') : added ? this.say('added') : this.say('add', {price:'£5'});
      this.removeButton.hidden = !added;
      this.removeButton.disabled = this.busy || ownerBusy;
      this.querySelector('[data-mystery-size]').textContent = added ? this.say('added_size',{size:this.lineSize()}) : this.owner.size ? this.say('selected_size',{size:this.owner.size}) : this.say('size_hint');
      this.owner.dataset.mysteryUpdating = String(this.busy || this.uncertain || !this.ready);
      if (this.uncertain && !added) { this.review.hidden = false; this.announce('uncertain'); }
    }

    async sizeChanged() {
      if (this.owner.size && this.status.textContent === this.say('choose_size')) this.status.textContent = '';
      this.render();
      if (!this.line || !this.owner.size || this.lineSize() === this.owner.size || this.busy) return;
      await this.remove(true);
    }

    async add() {
      if (this.busy || this.owner.busy || this.uncertain || this.line) return;
      if (!this.owner.size) { this.announce('choose_size'); this.owner.showSizeError?.(); return; }
      const variant = this.selected();
      if (!variant?.available || variant.price !== 500) { this.announce('unavailable'); return; }
      this.busy = true; this.operation = 'add'; this.review.hidden = true; this.render();
      let mutationStarted = false;
      try {
        await this.sync();
        if (this.line) return;
        const productPath = this.dataset.productUrl.replace(this.dataset.rootUrl, '').replace(/^\//, '') + '.js';
        const product = await this.request(productPath);
        const fresh = product.variants.find(v => Number(v.id) === Number(variant.id));
        if (Number(product.id) !== Number(this.dataset.productId) || !fresh?.available || fresh.price !== 500) throw new Error('unavailable');
        this.markPending(); mutationStarted = true;
        await this.request('cart/add.js', {items:[{id:variant.id,quantity:1,properties:{_et_upsell_offer:offer,_et_upsell_source:'product_page',_et_source_product_id:this.dataset.sourceProduct}}],sections:['cart-icon-bubble','cart-drawer'],sections_url:location.pathname});
        const cart = await this.sync();
        if (!this.line || Number(this.line.variant_id) !== Number(variant.id)) throw new Error('unconfirmed');
        this.announce('added_message',{size:variant.option1});
        this.refreshCartUI(cart);
      } catch (error) {
        if (mutationStarted) {
          try { await this.sync(); } catch (_) {}
          if (this.line) this.announce('added_message',{size:this.lineSize()});
          else if (error.status >= 400 && error.status < 500) { this.clearPending(); this.announce('failed'); }
          else { this.markPending(); this.announce('uncertain'); this.review.hidden = false; }
        } else this.announce(error.message === 'unavailable' ? 'unavailable' : error.message === 'currency' ? 'currency_changed' : 'failed');
      } finally {
        this.busy = false; this.render();
        if (this.line && this.owner.size && this.lineSize() !== this.owner.size) await this.remove(true);
        else if (this.owner.size) await this.owner.refresh();
      }
    }

    async remove(sizeChanged) {
      if (this.busy || this.owner.busy) return;
      this.busy = true; this.operation = 'remove'; this.review.hidden = true; this.render();
      try {
        let cart = await this.sync();
        const lines = this.matching(cart);
        for (const line of lines) cart = await this.request('cart/change.js', {id:line.key,quantity:0});
        this.clearPending();
        await this.sync();
        if (this.line) throw new Error('remove');
        this.announce(sizeChanged ? 'size_changed' : 'removed_message',{size:this.owner.size});
        this.refreshCartUI(cart);
      } catch (_) {
        try { await this.sync(); } catch (_) {}
        this.announce('failed'); this.review.hidden = false;
      } finally { this.busy = false; this.render(); if (this.owner.size) await this.owner.refresh(); }
    }

    async refreshCartUI(cart) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'evertee-mystery-upsell',cartData:cart});
      document.dispatchEvent(new CustomEvent('evertee:mystery-upsell-change',{detail:{productId:this.dataset.productId,added:!!this.line}}));
      try {
        const sections = await this.request('?sections=cart-icon-bubble,cart-drawer');
        const parser = new DOMParser();
        if (sections['cart-icon-bubble']) {
          const source = parser.parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
          const target = document.getElementById('cart-icon-bubble');
          if (source && target) target.innerHTML = source.innerHTML;
        }
        if (sections['cart-drawer']) {
          const source = parser.parseFromString(sections['cart-drawer'],'text/html').querySelector('#CartDrawer');
          const target = document.querySelector('cart-drawer #CartDrawer');
          if (source && target) {
            target.innerHTML = source.innerHTML;
            document.querySelector('cart-drawer')?.classList.toggle('is-empty',cart.item_count === 0);
          }
        }
      } catch (_) {}
    }
  }
  if (!customElements.get('evertee-mystery-upsell')) customElements.define('evertee-mystery-upsell', EverteeMysteryUpsell);
})();
  } catch(e) { console.error(e); }
})();

})();
